/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Shortcut_Keys_Import_Failed_ToastInputs */

const en_shortcut_keys_import_failed_toast = /** @type {(inputs: Shortcut_Keys_Import_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed importing shortcuts with error: ${i?.error}`)
};

const fr_shortcut_keys_import_failed_toast = /** @type {(inputs: Shortcut_Keys_Import_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Echec de l'import des raccourcis : ${i?.error}`)
};

const de_shortcut_keys_import_failed_toast = /** @type {(inputs: Shortcut_Keys_Import_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehler beim Importieren der Verknüpfungen: ${i?.error}`)
};

const it_shortcut_keys_import_failed_toast = /** @type {(inputs: Shortcut_Keys_Import_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile importare i collegamenti con errore: ${i?.error}`)
};

const ru_shortcut_keys_import_failed_toast = /** @type {(inputs: Shortcut_Keys_Import_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось импортировать ярлыки с ошибкой: ${i?.error}`)
};

const es_shortcut_keys_import_failed_toast = /** @type {(inputs: Shortcut_Keys_Import_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al importar accesos directos con el error: ${i?.error}`)
};

const zh_cn2_shortcut_keys_import_failed_toast = /** @type {(inputs: Shortcut_Keys_Import_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`导入快捷方式失败，错误信息：${i?.error}`)
};

const ja_shortcut_keys_import_failed_toast = /** @type {(inputs: Shortcut_Keys_Import_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ショートカットのインポートに失敗しました。エラー: ${i?.error}`)
};

const hi_shortcut_keys_import_failed_toast = /** @type {(inputs: Shortcut_Keys_Import_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`शॉर्टकट आयात करने में त्रुटि आई: ${i?.error}`)
};

const pt_pt2_shortcut_keys_import_failed_toast = /** @type {(inputs: Shortcut_Keys_Import_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao importar atalhos com o erro: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Failed importing shortcuts with error: {error}" |
*
* @param {Shortcut_Keys_Import_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_import_failed_toast = /** @type {((inputs: Shortcut_Keys_Import_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Import_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_import_failed_toast(inputs)
	if (locale === "de") return de_shortcut_keys_import_failed_toast(inputs)
	if (locale === "it") return it_shortcut_keys_import_failed_toast(inputs)
	if (locale === "ru") return ru_shortcut_keys_import_failed_toast(inputs)
	if (locale === "es") return es_shortcut_keys_import_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_import_failed_toast(inputs)
	if (locale === "ja") return ja_shortcut_keys_import_failed_toast(inputs)
	if (locale === "hi") return hi_shortcut_keys_import_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_import_failed_toast(inputs)
	return en_shortcut_keys_import_failed_toast(inputs)
});